
// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://njfdfadvuqlysldgtnmr.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im5qZmRmYWR2dXFseXNsZGd0bm1yIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMyNjAwMjUsImV4cCI6MjA1ODgzNjAyNX0.RwQE121Ixk5YBm2aFyzZtPN-UUGabUGyVgPl561KxbI";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

// Force clear session on initialization for debugging
const clearSession = () => {
  const storageKey = 'feedmyback:auth';
  // Check if we should clear session storage (add ?clear_session=true to URL)
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('clear_session') === 'true') {
    console.log('Clearing session storage due to URL parameter');
    localStorage.removeItem(storageKey);
    // Remove the parameter from URL
    urlParams.delete('clear_session');
    window.history.replaceState({}, document.title, 
      window.location.pathname + (urlParams.toString() ? '?' + urlParams.toString() : ''));
  }
};

// Initialize session clearing
clearSession();

// Initialize Supabase client with improved config
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storage: localStorage,
    storageKey: 'feedmyback:auth',
    detectSessionInUrl: true
  }
});

// Augmentation du type pour inclure les fonctions RPC
declare module '@supabase/supabase-js' {
  interface SupabaseClient<Database = any> {
    rpc<T extends object>(
      fn: 'set_admin_role' | 'toggle_user_active_status' | 'sync_users_and_profiles' | 'get_all_users' | 
          'check_feedback_access' | 'get_billing_plans' | 'toggle_billing_plan_status' | 
          'update_billing_plan' | 'create_billing_plan' | 'delete_billing_plan',
      params?: object
    ): Promise<{ data: T; error: Error | null }>;
  }
}

// Added type helper to work with tables not yet in the type definitions
export const fromTable = <T = any>(tableName: string) => {
  // Using a more aggressive type assertion that bypasses TypeScript's type checking
  // This is necessary for tables that aren't yet in the Database type definition
  return supabase.from(tableName as any) as any;
};
